import { http } from '@/http'

export default {
  downloadTemplate() {
    return http.get('/medical-leaves/bulk-upload/template', { responseType: 'blob' })
  },
  validate(file) {
    const formData = new FormData()
    formData.append('file', file)
    return http.post('/medical-leaves/bulk-upload/validate', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },
  confirm(batchId) {
    return http.post(`/medical-leaves/bulk-upload/confirm/${batchId}`)
  },
  downloadErrors(batchId) {
    return http.get(`/medical-leaves/bulk-upload/errors/${batchId}`, { responseType: 'blob' })
  },
}
